import _ from 'lodash'

// //////////////////////////////////////////////////////////////////////////////////
// CONSTANTS
// //////////////////////////////////////////////////////////////////////////////////

export const SET = 'pp.admin/generic/SET'
export const UNSET = 'pp.admin/generic/UNSET'
export const RESET = 'pp.admin/generic/RESET'
export const MERGE = 'pp.admin/generic/MERGE'
export const ASSIGN = 'pp.admin/generic/ASSIGN'

// //////////////////////////////////////////////////////////////////////////////////
// ACTIONS
// //////////////////////////////////////////////////////////////////////////////////

export const set = payload => ({ type: SET, payload })
export const unset = payload => ({ type: UNSET, payload })
export const merge = payload => ({ type: MERGE, payload })
export const assign = payload => ({ type: ASSIGN, payload })
export const reset = () => ({ type: RESET })

// //////////////////////////////////////////////////////////////////////////////////
// REDUCER
// //////////////////////////////////////////////////////////////////////////////////
const initialState = {}

export default function reducer(state = initialState, action) {
	const nextState = _.cloneDeep(state)

	switch (action.type) {
		case SET:
			return _.set(nextState, action.payload.path, action.payload.data)

		case ASSIGN:
			return Object.assign(nextState, action.payload)

		case MERGE:
			return _.merge(nextState, action.payload)

		case UNSET:
			_.unset(nextState, action.payload.path)
			return nextState

		case RESET:
			return initialState

		default:
			return state
	}
}
